import { useMemo } from "react";
import { TYPE_TO_FORMATTER, formatMinutesBalance } from "../common/formatting";
import InfoCard from "./InfoCard";
import StatusBanner from "./StatusBanner";
import { lastVisitedAt } from "../domain/customer";
import { useTranslation } from "../i18n";

/**
 * @param {object} props
 * @param {RegisteredCustomer} props.customer
 * @returns {React.Component}
 */
export default function CustomerInfo({ customer }) {
  const { t } = useTranslation();
  const balanceInfo = useMemo(
    () =>
      formatMinutesBalance(
        customer.debt ? customer.debt : customer.minutesBalance,
      ),
    [customer.debt, customer.minutesBalance],
  );

  const balanceHeading = (
    <div className="flex items-end">
      {balanceInfo.hours ? (
        <>
          <h1 className="mr-1">{balanceInfo.hours.toString()}</h1>
          {t("customer.hours")}
          <span className="w-4" />
        </>
      ) : null}
      <h1 className="mr-1">{balanceInfo.minutes.toString()}</h1>
      {t("customer.minutes")}
    </div>
  );

  const balanceComment = `${customer.debt ? customer.debt : customer.minutesBalance} ${t("customer.minutes")}`;

  return (
    <>
      <div className="grid grid-cols-3 gap-3 xl:gap-4">
        <InfoCard
          heading={TYPE_TO_FORMATTER["phone"](customer.phone)}
          subheading={t("customer.phone")}
        />
        <InfoCard heading={customer.email} subheading={t("customer.email")} />
        <InfoCard
          heading={
            <span className="text-4xl">
              {customer.debt ? (
                <span className="text-red-400">{balanceHeading}</span>
              ) : (
                balanceHeading
              )}
            </span>
          }
          subheading={
            customer.debt ? t("customer.debt") : t("customer.balance")
          }
          comment={
            customer.debt ? (
              <span className="text-red-400">{balanceComment}</span>
            ) : (
              balanceComment
            )
          }
          className="row-span-2"
        />
        <InfoCard
          heading={
            customer.birthDate
              ? new Date(customer.birthDate).toLocaleDateString()
              : "-"
          }
          subheading={t("customer.birthDate")}
        />
        {customer.tierInfo?.vipEnabled ? (
          <InfoCard>
            <StatusBanner bars={customer.tierInfo.bars} />
          </InfoCard>
        ) : (
          <InfoCard
            heading={
              lastVisitedAt(customer)
                ? `${lastVisitedAt(customer).toLocaleDateString()} ${lastVisitedAt(customer).toLocaleTimeString()}`
                : "-"
            }
            subheading={t("customer.lastVisit")}
          />
        )}
      </div>
    </>
  );
}
